// composables/useWarningModal.js
import { ref } from 'vue'
import { useBootstrapModal } from '@/composables/useBootstrapModal'

let warningModalInstance // cached instance

export const useWarningModal = () => {
  if (warningModalInstance) return warningModalInstance

  const { openModal, closeModal } = useBootstrapModal("warning_modal")

  const modalTitle = ref("ابلاغ عن تقييم")
  const firstText = ref("")
  const secondText = ref("")

  const showModal = (newModalTitle = '', newFirstText = '', newSecondText = '') => {
    modalTitle.value = newModalTitle
    firstText.value = newFirstText
    secondText.value = newSecondText
    setTimeout(() => {
      openModal()
      setTimeout(() => {
        // hideModal()
      }, 3000)
    }, 500)
  }

  const hideModal = () => {
    modalTitle.value = ''
    firstText.value = ''
    secondText.value = ''
    closeModal()
  }

  warningModalInstance = {
    showModal,
    modalTitle,
    firstText,
    secondText,
    hideModal,
  }

  return warningModalInstance
}
